import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/ecommerceSeoData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const EcommerceSEO = () => {
    useMetaTags({
      title:
        "Top eCommerce SEO Services by Warrgyizmorsch | Expert Internet Marketing Agency",
      description:
        "Warrgyizmorsch offers powerful eCommerce SEO services to boost search rankings, drive targeted traffic, and maximize your online store’s performance.",
      keywords:
        "eCommerce SEO , Expert eCommerce SEO Services, ecommerce seo services, Ecommerce SEO Agency, ecommerce seo marketing, ecommerce seo optimization, Ecommerce SEO Strategies, e commerce website seo, ecommerce seo companies, ecommerce seo expert, ecommerce seo consultant",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Enhance Your Digital Reach with Results-Driven Ecommerce SEO
                  Strategies
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/eCommerceSeo.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    In today’s competitive online environment what it takes is a
                    robust digital presence for success. At Warrgyizmorsch we
                    focus on what we do best which is to increase traffic and
                    sales for eCommerce businesses via made to measure SEO
                    solutions. We aim to improve the visibility of your site on
                    search engines, bring in that target audience and in the end
                    increase your sales.
                  </p>
                </div>
              </div>
              {/* Expert eCommerce SEO Services  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* Our Strategy for E-commerce SEO Services  */}
              <Benefits_section data={BenefitSection} />
              
              {/* Expanding Your Online Store with eCommerce SEO  */}
              <Role_writing data={roleWriting} />

              {/* How Warrgyizmorsch Can Speed Up Your Business Growth?  */}
              <Boost_section data={BoostSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default EcommerceSEO;